import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {Track} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {get} = requestWrapper;

const requests = {
	get: (isrc: string, deezerId?: number) =>
		get<DataResponseWrapper<Track>>(endpoints.trackByISRC(isrc), {
			params: {
				deezerId: deezerId || undefined,
			},
		}),
};

export default requests;
